import * as React from "react";

import { DiplomaTaskList } from "./DiplomaTaskList";

export interface IDashboardSportPageProps {
  searchUnassignedTitles: boolean;
}

export const DashboardSportPage: React.FunctionComponent<IDashboardSportPageProps> = ({
  searchUnassignedTitles,
}) => {
  return (
    <div>
      <DiplomaTaskList searchUnassignedTitles={searchUnassignedTitles} />
    </div>
  );
};
